import React from "react";

import { Box, Button } from "@mui/material";

import { useAuth } from "../../context/AuthContext";
import GenericNavItem from "../GenericNavItem";
import GenericButton from "../GenericButton";
import { globalBg } from "../../styles/theme";

export const SignInButton = () => {
  const { logIn } = useAuth();

  return (
    <Box sx={{ borderLeft: "1px solid", borderColor: globalBg }}>
      <GenericButton text="Login" onClick={() => logIn()} />
    </Box>
  );
};
